import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { corporateCMSApi } from "~/Services";
import { PageHeading } from "../../MediaCentre/Media.hook";

interface DocumentDetailsResponse {
  id: number;
  title: string;
  field_agency_title_ms: string;
  field_agency_title_zh: string;
  field_agency_link_en: string;
  field_agency_link_ms: string;
  field_agency_link_zh: string;
  field_agency_image: string;
  field_agency_page_en: string;
  field_agency_page_ms: string;
  field_agency_page_zh: string;
  field_agency_order_sequence: number;
  published: boolean;
  created_at: string;
  updated_at: string;
}
interface NewsNextPage {
  id: number;
  title: string;
  field_content_english: {
    data: {
      nextPage: {
        name: string;
        link: string;
      };
    };
  };
  field_content_malay: {
    data: {
      nextPage: {
        name: string;
        link: string;
      };
    };
  };
  field_content_mandarin: {
    data: {
      nextPage: {
        name: string;
        link: string;
      };
    };
  };
  field_page: string;
  published: boolean;
  createdAt: string;
  updatedAt: string;
}

// edit api call
const fetchGroundHolderDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await corporateCMSApi.get(`/api/get-agencies/${id}`);
  return response.data[0];
};

const useGroundHolderDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["groundHoldersDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchGroundHolderDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

const useGroundHoldersPageHeading = (
  options?: UseQueryOptions<PageHeading[], DefaultError, PageHeading[], QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<PageHeading[], DefaultError> => {
  return useQuery<PageHeading[], DefaultError, PageHeading[], QueryKey>(
    {
      queryKey: ["groundHandlersPageHeading"],
      enabled: false,
      queryFn: async (): Promise<PageHeading[]> => {
        const response = await corporateCMSApi.get<PageHeading[]>(
          `/api/page-heading/all-fields?pageName=business/stakeholders/ground-handlers`
        );
        return response.data;
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};
const useGroundHandlersNextPage = (
  options?: UseQueryOptions<NewsNextPage[], DefaultError, NewsNextPage[], QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<NewsNextPage[], DefaultError> => {
  return useQuery<NewsNextPage[], DefaultError, NewsNextPage[], QueryKey>(
    {
      queryKey: ["groundHandlersNextPage"],
      enabled: false,
      queryFn: async (): Promise<NewsNextPage[]> => {
        const response = await corporateCMSApi.get<NewsNextPage[]>(
          `/api/page-content/all-fields?pageName=business/stakeholders/ground-handlers`
        );
        return response.data;
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};
export { useGroundHandlersNextPage, useGroundHolderDocumentDetails, useGroundHoldersPageHeading };
